/* HFYF: clean product names in the cart, cart popup, search and the browser tab (same rules as snippets/hfyf-title) */
(function () {
  function clean(t) {
    var s = t.trim().replace(/^\[?HY\d+\]?\s+/i, '');
    s = s.replace(/^Size\s+[\d.]+W?\s+((\(?pre-?owned\)?|vnds|pads|used|tried\s+on|\(nb\)|nb|\(rb\)|\(rep box\))\s+)*/i, '');
    s = s.replace(/’/g, "'").replace(/[‘“”"]/g, '').replace(/ '([A-Z])/g, ' $1').replace(/' /g, ' ').replace(/'$/, '');
    s = s.replace(/\(W\)/g, "(Women's)").replace(/\(F&F\)|\(Friends & Family\)/g, '(Friends and Family)').replace(/^Adidas /, 'adidas ').replace(/\s{2,}/g, ' ');
    return s.trim();
  }
  var SEL = '.cart-item__name, .cart-notification-product__name, .predictive-search__item-heading, .card-information__text, .product-popup-modal__content h1';
  function each(el) {
    if (el.dataset.hfClean) return;
    var n = el.childNodes.length === 1 && el.firstChild.nodeType === 3 ? el.firstChild : null;
    if (n) { var c = clean(n.nodeValue); if (c !== n.nodeValue.trim()) n.nodeValue = c; }
    el.dataset.hfClean = '1';
  }
  function run(scope) {
    if (scope.matches && scope.matches(SEL)) each(scope);
    scope.querySelectorAll(SEL).forEach(each);
  }
  var dt = clean(document.title); if (dt !== document.title) document.title = dt;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); }); else run(document);
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (x) { if (x.nodeType === 1 && x.className !== 'hf-trail') run(x); }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* HFYF: precise search. Shopify's semantic search pads results with related pairs (e.g. other Travis Scotts for
   "reverse mocha"). On page 1 we gather every result page and keep only the products whose name contains every
   search word (or, if none do, the ones that match the most words). */
(function () {
  if (location.pathname.indexOf('/search') !== 0) return;
  var p = new URLSearchParams(location.search);
  var q = (p.get('q') || '').toLowerCase().trim();
  if (!q || p.get('type') === 'article' || (p.get('page') || '1') !== '1') return;
  var STOP = { and: 1, the: 1, x: 1, of: 1, a: 1, for: 1, with: 1, in: 1 };
  var terms = q.replace(/[’']/g, '').replace(/[^\w\s.-]/g, ' ').split(/\s+/).filter(function (t) { return t && !STOP[t] && (t.length > 1 || /\d/.test(t)); });
  if (!terms.length) return;
  var res = terms.map(function (t) { return new RegExp('(^|[^a-z0-9])' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-z0-9]|$)'); });
  function go() {
    var host = document.getElementById('product-grid');
    var grid = host && (host.tagName === 'UL' ? host : host.querySelector('ul'));
    if (!grid || grid.dataset.hfFiltered) return;
    grid.dataset.hfFiltered = '1';
    var pages = 1;
    document.querySelectorAll('.pagination__list a, .pagination__list span').forEach(function (a) { var n = parseInt(a.textContent, 10); if (n > pages) pages = n; });
    var cntEl = document.querySelector('#ProductCountDesktop, #ProductCount, .product-count__text');
    var total = cntEl ? parseInt(cntEl.textContent, 10) : 0;
    if (total > grid.children.length && grid.children.length) pages = Math.max(pages, Math.ceil(total / grid.children.length));
    var jobs = [];
    for (var i = 2; i <= Math.min(pages, 8); i++) {
      var pp = new URLSearchParams(location.search); pp.set('page', i); pp.set('section_id', 'main-search');
      jobs.push(fetch(location.pathname + '?' + pp.toString()).then(function (r) { return r.text(); }).catch(function () { return ''; }));
    }
    Promise.all(jobs).then(function (htmls) {
      var items = [].slice.call(grid.children);
      htmls.forEach(function (h) { var g = new DOMParser().parseFromString(h, 'text/html').getElementById('product-grid'); g = g && (g.tagName === 'UL' ? g : g.querySelector('ul')); if (g) items = items.concat([].slice.call(g.children)); });
      var scored = items.map(function (li) {
        var a = li.querySelector('.card__heading a');
        var name = (a ? a.textContent : '').toLowerCase().replace(/[’']/g, '');
        var s = 0; res.forEach(function (re) { if (re.test(name)) s++; });
        return { li: li, s: s };
      });
      var max = 0; scored.forEach(function (x) { if (x.s > max) max = x.s; });
      if (!max) return;
      var keep = scored.filter(function (x) { return x.s === max; });
      grid.innerHTML = '';
      keep.forEach(function (x) { grid.appendChild(document.importNode(x.li, true)); });
      var pag = document.querySelector('.pagination-wrapper'); if (pag) pag.style.display = 'none';
      document.querySelectorAll('#ProductCountDesktop, #ProductCount, .product-count__text').forEach(function (el) { el.textContent = keep.length + (keep.length === 1 ? ' result' : ' results'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* HFYF: SEO tidy-up for Google's renderer: clean product name + brand in structured data, real alt text on photos */
(function () {
  function fix() {
    var h1 = document.querySelector('.product__title h1');
    var name = h1 ? h1.textContent.trim() : '';
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
      try {
        var j = JSON.parse(s.textContent), ch = false;
        if (j['@type'] === 'Organization') { j.name = 'HFYF'; j.legalName = 'HFYF, Inc.'; j.sameAs = ['https://www.instagram.com/heat.forya.feet/']; ch = true; }
        if (j['@type'] === 'Product' && name) { j.name = name; ch = true; }
        if (ch) s.textContent = JSON.stringify(j);
      } catch (e) {}
    });
    if (name) document.querySelectorAll('.product__media img, .product-media-modal img').forEach(function (im, i) { if (!im.alt || /^https?:/.test(im.alt)) im.alt = name + (i ? ' - photo ' + (i + 1) : ''); });
    document.querySelectorAll('img[alt^="http"]').forEach(function (im) {
      var c = im.closest('.card-wrapper, .hf-card'); var t = c && c.querySelector('.card__heading a, .hf-card__name');
      im.alt = t ? t.textContent.trim() : name;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();

(function () {
  if (!window.matchMedia || window.matchMedia('(hover: none), (pointer: coarse), (prefers-reduced-motion: reduce)').matches) return;
  var base = 'https://cdn.shopify.com/s/files/1/0667/4045/3626/files/';
  var shoes = [
    'Air-Jordan-1-Retro-Low-OG-SP-Travis-Scott-Reverse-Mocha_V2-Product.webp',
    'Louis-Vuitton-Nike-Air-Force-1-Low-By-Virgil-Abloh-White-Green-Product.webp',
    'Nike-SB-Dunk-Low-Medicom-1-Product.webp',
    'Air-Jordan-4-Retro-White-Thunder-Product_jcwrjs.jpg',
    'Nike-Air-Max-1-97-Sean-Wotherspoon-NA-Product_apd9d5.jpg',
    'Air-Foamposite-One-Supreme-NYC-Black-Product_qrlyeo_6d4a487e-516f-4957-bee8-76f2423d0400.jpg',
    'Nike-Dunk-SB-Low-Stingwater-Magic-Mushroom-Product_poj1yf.jpg',
    'Air-Jordan-1-Retro-High-Union-Los-Angeles-Blue-Toe-Product_nmfizn.jpg',
    'Nike-Air-Force-1-Low-SP-Tiffany-And-Co-Product_tb6o9v.jpg',
    'Nike-Air-Max-90-Off-White-Desert-Ore-Product_991ff861-2b22-4e6f-818e-80cc471f0b94.webp',
    'Nike-Dunk-SB-Low-Raygun-Product.webp',
    'Air-Jordan-1-Retro-Low-OG-SP-Fragment-x-Travis-Scott-Sail-Military-Blue-Product-v2_e9028b32-2598-4026-8cad-d62cc20fbf6d.webp',
    'Louis-Vuitton-Nike-Air-Force-1-Low-By-Virgil-Abloh-White-Royal-Product.webp',
    'Nike-Air-Max-1-Atmos-Safari-2002_ibnzt6_5d6d304f-98b7-451e-a296-846dceb7a467.jpg',
    'Nike-SB-Dunk-Low-Girls-Dont-Cry-Product.webp',
    'New-Balance-1906R-Salehe-Bembury-Heat-Be-Hot-Magma-Product_sldt89_59b7e833-8150-422f-a5cb-2faef08752e9.jpg',
    'Air-Jordan-1-Retro-High-Dark-Mocha-2-Product_ncatzl.jpg',
    'Nike-Air-Force-1-Low-OFF-WHITE-University-Gold-Metallic-Silver-Product_wqeqhu.jpg',
    'Nike-Dunk-SB-Low-Tokyo-Blue-Taxi-Product.webp',
    'Nike-Air-Max-1-Travis-Scott-Baroque-Brown-Product_bj8u0u.jpg',
    'Nike-Dunk-Low-Premuim-SB-SBTG-Product.webp',
    'Air-Jordan-1-Retro-Low-OG-SP-Travis-Scott-Canary-Womens-Product_a130e202-4824-4e36-8ed6-1269816c6c1f.webp',
    'Nike-Air-Max-97-Off-White-Menta-Product_yyhag1.jpg',
    'Nike-SB-Dunk-High-Reverse-Skunk-420-Special-Box-Product_q2v9id.jpg',
    'Louis-Vuitton-Nike-Air-Force-1-Low-By-Virgil-Abloh-White-Red-Product_1589df95-7f62-4b68-9762-d963e1d42e6b.webp',
    'Nike-Air-Max-Lunar90-Moon-Landing-Product_myrkxc.jpg',
    'Nike-Dunk-SB-Low-Jedi-Product.webp',
    'Air-Jordan-1-Retro-Low-OG-SP-Travis-Scott-Velvet-Brown-Product.webp',
    'adidas-Adistar-Jellyfish-Pharrell-Williams-Triple-Black-Product.webp',
    'Nike-Air-Max-95-Atmos-Animal-Pack-Product_vvline_7c08d8d1-3656-4a47-95fc-de9d7c752068.jpg',
    'Nike-SB-Dunk-Low-Pro-Takashi-2003.webp',
    'Nike-Air-Max-1-Travis-Scott-Wheat-Product_kbjpvq.jpg',
    'Nike-Dunk-SB-Low-Michael-Lau-Gardener-Wood.webp',
    'Air-Jordan-1-Retro-Low-OG-SP-Medium-Olive-Product_2b1cda47-3bc1-4788-914b-b6ddd3ef1587.webp',
    'Nike-Air-Max-97-Silver-Bullet-2016-Product_aogni7_15b928fc-5660-4691-b3b4-f0a90c10df51.jpg',
    'Nike-SB-Dunk-Low-Neptune.webp',
    'Nike-Air-Max-90-Off-White-Product_ldxdje_25543f82-205b-4624-b203-28829ccd6088.jpg',
    'Nike-Dunk-SB-Low-Barf-Product_k7rzml.jpg'
  ].map(function (f) { return base + f + '?width=240'; });
  /* shuffle once per visit so every session feels different */
  for (var k = shoes.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)), t = shoes[k]; shoes[k] = shoes[j]; shoes[j] = t; }
  var loaded = {};
  function preload(i) { var s = shoes[i % shoes.length]; if (!loaded[s]) { loaded[s] = 1; var im = new Image(); im.src = s; } }
  for (var p = 0; p < 6; p++) preload(p);
  var lastX = 0, lastY = 0, lastT = 0, n = 0, live = 0;
  window.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var dx = e.clientX - lastX, dy = e.clientY - lastY, now = performance.now();
    if (Math.sqrt(dx * dx + dy * dy) < 80 || now - lastT < 50 || live > 14) return;
    lastX = e.clientX; lastY = e.clientY; lastT = now;
    preload(n + 6);
    var img = document.createElement('img');
    img.src = shoes[n++ % shoes.length];
    img.alt = ''; img.setAttribute('aria-hidden', 'true'); img.className = 'hf-trail';
    img.style.left = e.clientX + 'px'; img.style.top = e.clientY + 'px';
    var rot = (Math.random() * 24 - 12).toFixed(1), flip = dx < 0 ? -1 : 1;
    document.body.appendChild(img); live++;
    var anim = img.animate([
      { opacity: 0, transform: 'translate(-50%,-50%) rotate(' + rot + 'deg) scale(' + (0.6 * flip) + ',0.6)' },
      { opacity: 1, transform: 'translate(-50%,-50%) rotate(' + rot + 'deg) scale(' + flip + ',1)', offset: 0.15 },
      { opacity: 0, transform: 'translate(-50%,-20%) rotate(' + rot + 'deg) scale(' + (0.8 * flip) + ',0.8)' }
    ], { duration: 950, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' });
    anim.onfinish = function () { img.remove(); live--; };
  }, { passive: true });
})();

/* 5) Product page balance: keep the photo column and the info column ending together.
   Long content (description, trust, help) moves into a full-width "Details" band under the
   product when the photos are shorter than the info column. Re-checks on resize/image load. */
(function () {
  var main = document.querySelector('.product.grid');
  if (!main) return;
  var mediaCol = main.querySelector('.product__media-wrapper');
  var info = main.querySelector('.product__info-container');
  if (!mediaCol || !info) return;
  var movers = [
    { sel: '.product__description', slot: 'a' },
    { sel: '.hf-ptrust', slot: 'b' },
    { sel: '.hf-phelp', slot: 'b' }
  ].map(function (m) {
    var el = info.querySelector(m.sel);
    if (!el) return null;
    var mark = document.createComment('hf-slot');
    el.parentNode.insertBefore(mark, el);
    return { el: el, mark: mark, slot: m.slot };
  }).filter(Boolean);
  if (!movers.length) return;

  var band = document.createElement('section');
  band.className = 'hf-more page-width';
  band.innerHTML = '<div class="hf-more__col hf-more__a"><h2 class="hf-more__h">Details</h2></div><div class="hf-more__col hf-more__b"></div>';
  main.parentNode.insertBefore(band, main.nextSibling);
  var slotA = band.querySelector('.hf-more__a'), slotB = band.querySelector('.hf-more__b');

  function restore() {
    movers.forEach(function (m) { if (m.el.parentNode !== m.mark.parentNode) m.mark.parentNode.insertBefore(m.el, m.mark.nextSibling); });
  }
  function balance() {
    restore();
    band.classList.remove('is-on');
    if (window.innerWidth < 990) return;
    var g = (mediaCol.querySelector('media-gallery') || mediaCol).getBoundingClientRect().height;
    var i = info.getBoundingClientRect().height;
    var moved = false;
    for (var k = 0; k < movers.length && i > g + 120; k++) {
      var m = movers[k];
      (m.slot === 'a' ? slotA : slotB).appendChild(m.el);
      moved = true;
      i = info.getBoundingClientRect().height;
    }
    if (moved) {
      band.classList.add('is-on');
      if (!slotA.querySelector('.product__description')) slotA.querySelector('.hf-more__h').style.display = 'none';
      else slotA.querySelector('.hf-more__h').style.display = '';
    }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(balance, 120); }
  window.addEventListener('resize', soon);
  window.addEventListener('load', balance);
  mediaCol.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', soon); });
  balance();
})();
